import React from "react";

const MyRewards = () => {
  return <div>MyRewards</div>;
};

export default MyRewards;
